/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as signInReducer } from "./signInSlice";

/** Synchronous actions (form, focus, DBS and orchestration resets). */
export {
  setActiveTab,
  setUserId,
  setPassword,
  setRecoveryEmail,
  togglePasswordVisibility,
  setAuthCode,
  setQrCodeUrl,
  markAuthTypeAttempted,
  setAuthOrchestrationStatus,
  setIpAutoLoginStatus,
  sessionInvalidated,
  resetAuthOrchestration,
  resetSignInState,
  clearSignInError,
  resetPasswordFlowState,
  setMobileDialogDismissed,
  setFocusedField,
  focusNext,
  focusPrev,
  switchTabLeft,
  switchTabRight,
  cancelDbsPolling,
  resetDbsState
} from "./signInSlice";

/** One module per authentication flow — see thunks/index.ts. */
export * from "./thunks";

/** One module per authentication flow — see selectors/index.ts. */
export * from "./selectors";

/** Need Help alert payload — reads Branding/DeviceModel/Locale for the view. */
export {
  buildNeedHelpMessage,
  getCustomerSupportPhoneNumber,
  getNeedHelpAlertConfig
} from "./needHelpAlert";

/** Sign-in error alert — code display and per-code recovery actions. */
export {
  buildAuthConfigErrorAlert,
  buildSignInErrorAlert,
  buildSignInErrorMessage
} from "./signInErrorAlert";
export {
  isTerminalSignInError,
  resolveSignInErrorActions,
  SignInErrorAction
} from "./common/signInErrorActions";
export type { SignInErrorActionId } from "./common/signInErrorActions";

/** Background DBS polling cleanup for the connection overlay's Exit path. */
export { stopDbsPolling } from "./common";

/** The connection overlay's Sign In Again path: end the attempt in flight. */
export { cancelSignInSession } from "./common";
export { SIGN_IN_AGAIN_RETRY_ACTION_ID } from "./signIn.constants";

export type {
  SignInState,
  SignInFocusedField,
  DbsFlowStatus,
  DbsPollingStatus,
  DbsError,
  ResetIdentityPayload,
  AuthOrchestrationStatus,
  IpAutoLoginStatus,
  IpAutoLoginErrorCode,
  IpAutoLoginError,
  TLastAuthContext
} from "./signIn.types";
export { IP_AUTOLOGIN_EMPTY_CREDENTIAL_MESSAGE } from "./signIn.types";
